module.exports = __webpack_public_path__ + "img/119.a0836f66.png";